import { Component } from '@angular/core';

@Component({
  selector: 'rpe-dva1',
  standalone: true,
  
  templateUrl: './rpe-dva1.component.html',
  styleUrl: './rpe-dva1.component.scss'
})
export class RpeDva1Component {

}
